import { LevelPlayWordHunt as Activity } from '.'

export const SLUG = 'word_hunt'
export const activity = {
  SLUG,
  interactionMode: {
    kind: 'continue',
    waitValidation: true
  },
  Component: Activity
}
